(ns practitest.frontend.components2.dashboard.card
  (:require [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.buttons :refer [button icon-button]]
            [practitest.frontend.components2.dropdown :as dropdown]
            [practitest.frontend.components2.tooltip :refer [tooltip]]
            [re-frame.core :as r]))

(defn download-dropdown [items]
  [dropdown/dropdown-menu
   (fn [{:keys [toggle!]}]
     [:div.mux-card-dropdown-trigger.m-icon-button {:on-click toggle!}
      [icons/mux-three-dots]])
   {:placement "bottom-end"
    :strategy  "absolute"}
   (into [dropdown/dropdown-menu-body {}]
         (for [{:keys [evt] :as item} items
               :let [item (assoc item :on-click #(r/dispatch evt))]]
           [dropdown/dropdown-menu-item item]))])

(defn card-header
  "Card header with title, filter text, and action buttons.
   The filter text is omitted when `sub-title` is nil.
   `edit-disabled-tooltip` disables the edit button and explains why."
  [{:keys [title sub-title on-edit edit-disabled-tooltip dropdown-menu]}]
  (let [sub-title (when sub-title (str "Filter: " sub-title))]
    [:div.header
     [:div.title-section
      [tooltip
       (fn [props]
         [:p.title.clamped-text props title])
       title]
      (when sub-title
        [tooltip
         {:placement "right"}
         (fn [props]
           [:span.sub-title.clamped-text props sub-title])
         sub-title])]
     [:div.actions
        (when on-edit
          [button {:class     "action-btn m-icon-button"
                   :icon      [icons/mux-pencil]
                   :disabled? (some? edit-disabled-tooltip)
                   :tooltip   edit-disabled-tooltip
                   :on-click  on-edit}])
        (when dropdown-menu
          [download-dropdown dropdown-menu])]]))

(defn card
  [{:keys [class] :as props} & children]
  [:div.dashboard-item {:class class}
   [card-header props]
   (into [:div.content] children)])
